export default __webpack_public_path__ + "media/images/blank_page-e1c7d9bd936d24ee8f0186365d5098fa.gif";